import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <>
      <SEO 
        title="Siden blev ikke fundet (404) — Trailerregler.dk" 
        description="Siden findes ikke på Trailerregler.dk. Find vej til regler om kørekort, vægt, hastighed og syn her." 
        pathname="/404"
      />

      <article className="py-12 text-center">
        <span className="inline-block text-[13px] font-mono uppercase tracking-wider text-[#B58200] font-semibold mb-2">
          Fejlkode 404
        </span>
        <h1 className="text-[32px] font-bold text-[#2E3A46] tracking-tight mb-4">
          Siden blev ikke fundet
        </h1>
        <p className="text-[17px] text-[#5C636B] leading-relaxed max-w-[48ch] mx-auto mb-8">
          Den adresse, du har indtastet, findes ikke på Trailerregler.dk. Du kan benytte oversigterne herunder til at finde det emne, du søger.
        </p>

        <div className="flex flex-wrap justify-center gap-3 font-medium text-[15px]">
          <Link 
            to="/" 
            className="px-4 py-2 border border-[#2E3A46] bg-[#2E3A46] text-[#FBFAF6] rounded-[4px] hover:bg-[#B58200] hover:border-[#B58200] transition-colors"
          >
            Gå til forsiden
          </Link>
          <Link 
            to="/koerekort-og-trailer" 
            className="px-4 py-2 border border-[#E4E1D8] bg-[#FBFAF6] text-[#2E3A46] rounded-[4px] hover:bg-[#FBF3DA] transition-colors"
          >
            Kørekort &amp; trailer
          </Link>
          <Link 
            to="/trailer-hastighed" 
            className="px-4 py-2 border border-[#E4E1D8] bg-[#FBFAF6] text-[#2E3A46] rounded-[4px] hover:bg-[#FBF3DA] transition-colors"
          >
            Hastighedsgrænser
          </Link>
        </div>
      </article>
    </>
  );
}
